import { postRequest, downloadGetRequest } from '@/libs/axios';

// 推广统计列表
export const getRecommendationStatsList = (params) => {
    return postRequest('/api/recommendation/stats/list', params)
}

// 导出推广统计
export const exportRecommendationStats = (params) => {
    return postRequest('/api/recommendation/stats/export', params)
}

// 获取导出记录列表
export const getExportRecordList = (params) => {
    return postRequest('/api/export/record/list', params)
}

// 下载导出文件
export const downloadExportFile = (params) => {
    return downloadGetRequest('/api/export/download', params)
}